export const calculateSsortOrder = (frequencyCount, frequencyUnit) => {
  const sortOrderByFrequencyUnit = {
    year: 100,
    years: 100,
    month: 31,
    months: 31
  };

  const unitSortOrder = sortOrderByFrequencyUnit[frequencyUnit] || 0;
  const sortOrder = unitSortOrder + parseInt(frequencyCount);

  return sortOrder;
};
